import React from 'react';
import {
    Routes,
    Route
} from 'react-router-dom';

//views
import Home from 'views/Home/Home';
import NewPatient from 'views/NewPatient/NewPatient';
import SelfEnrollmentView from 'views/SelfEnrollment/SelfEnrollmentView';
import ErrorPage from 'views/ErrorView/ErrorView';

const RoutesMap = () => {
    const RoutesWithoutNavBar = ({ children }) => {
        return children;
    }
    return ( 
        <Routes>
            <Route
                path="/"
                element={
                    <RoutesWithoutNavBar>
                        <Home />
                    </RoutesWithoutNavBar>
                }
            />
            <Route
                path="/registro-pacientes"
                element={
                    <RoutesWithoutNavBar>
                        <NewPatient />
                    </RoutesWithoutNavBar>
                }
            />
            <Route
                path="/auto-registro"
                element={
                    <RoutesWithoutNavBar>
                        <SelfEnrollmentView />
                    </RoutesWithoutNavBar>
                }
            />
            <Route
                path="/error"
                element={
                    <RoutesWithoutNavBar>
                        <ErrorPage />
                    </RoutesWithoutNavBar>
                }
            />
        </Routes>    
    );
}
 
export default RoutesMap;